import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {CommonModule} from "@angular/common";
import {
    DxButtonComponent,
    DxPopupComponent,
    DxValidationGroupComponent
} from "devextreme-angular";
import {DxiPopupToolbarItemComponent} from "devextreme-angular/ui/popup";
import {TimeOffDto, TimeOffStatus} from "@services";
import {CapitalCasePipe} from "../../../../pipes/capital-case.pipe";

@Component({
    selector: 'app-time-off-request-modal',
    standalone: true,
    imports: [
        CommonModule,
        DxPopupComponent,
        DxiPopupToolbarItemComponent,
        DxButtonComponent,
        DxValidationGroupComponent,
        CapitalCasePipe
    ],
    templateUrl: './time-off-request-modal.component.html'
})
export class TimeOffRequestModalComponent {
    @Input() title: string;
    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();

    @Input() isScreenSmall: boolean;
    @Input() height: number | string = 480;

    @Input() canEdit: boolean = false;
    @Input() canApprove: boolean = false;
    @Input() canDecline: boolean = false;
    @Input() canWithdrawn: boolean = false;
    @Input() timeOffRequest?: TimeOffDto = new TimeOffDto();

    @Output() save = new EventEmitter<void>();
    @Output() statusChange = new EventEmitter<TimeOffStatus>();
    @Output() close = new EventEmitter<void>();
    @Output() shown = new EventEmitter<void>();

    @ViewChild('validationGroup', {static: true}) validationGroup: DxValidationGroupComponent;

    TimeOffStatus = TimeOffStatus;

    onShown() {
        this.shown.emit();
    }

    onClose() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
        this.validationGroup?.instance.reset();
        this.close.emit();
    }

    onSaveClick() {
        const result = this.validationGroup.instance.validate();
        if (result.isValid) {
            this.save.emit();
        }
    }

    changeStatus(status: TimeOffStatus) {
        this.statusChange.emit(status);
    }

    protected getBadgeClass(status: TimeOffStatus): string {
        switch (status) {
            case TimeOffStatus.Approved:
                return 'bg-success-subtle text-success';
            case TimeOffStatus.Declined:
                return 'bg-danger-subtle text-danger';
            case TimeOffStatus.Withdrawn:
                return 'bg-warning-subtle text-warning';
            case TimeOffStatus.Pending:
            default:
                return 'bg-info-subtle text-info';
        }
    }
}
